import { Card, CardContent, Typography, IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { motion } from "motion/react";
import { useEditMode } from "../context/EditModeContext";

interface ExpertiseCardProps {
  title: string;
  description: string;
  onEdit?: () => void;
}

export default function ExpertiseCard({ title, description, onEdit }: ExpertiseCardProps) {
  const { isEditMode } = useEditMode();

  return (
    <motion.div
      whileHover={{ scale: 1.03, boxShadow: "0px 8px 20px rgba(0,0,0,0.15)" }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      style={{ height: "100%" }}
    >
      <Card sx={{ position: "relative", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", p: 2 }}>
        {isEditMode && onEdit && (
          <IconButton
            size="small"
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={onEdit}
          >
            <Edit fontSize="small" />
          </IconButton>
        )}
        <CardContent>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">{description}</Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
}
